var HorizontalLayout1Module = /** @class */ (function () {
    function HorizontalLayout1Module() {
    }
    return HorizontalLayout1Module;
}());
export { HorizontalLayout1Module };
